if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.sectionId = this.dataset.section;
      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
      this.footerElement = document.querySelector('footer');
      this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    handleScroll() {
      if (!this.targetElement) return;

      const targetRect = this.targetElement.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      // Visible when main ATC is on screen
      const isMainAtcVisible = targetRect.bottom > 0 && targetRect.top < windowHeight;

      // Check if footer reached
      let isFooterInView = false;
      if (this.footerElement) {
        const footerRect = this.footerElement.getBoundingClientRect();
        isFooterInView = footerRect.top < windowHeight && footerRect.bottom > 0;
      }

      // Appears on page load / out of view, hides when main ATC or footer is reached
      if (!isMainAtcVisible && !isFooterInView) {
        this.classList.add('show');
      } else {
        this.classList.remove('show');
      }
    }

    handleVariantChange({ data: { sectionId, html, variant } }) {
      const mainSectionId = this.sectionId.replace(/^template--\d+__/, '');
      const eventSectionId = sectionId.replace(/^template--\d+__/, '');

      if (mainSectionId !== eventSectionId) return;
      if (!variant) return;

      // Sync hidden variant ID
      if (this.stickyAtcVariantInput) {
        this.stickyAtcVariantInput.value = variant.id;
      }

      // Sync button state
      const stickySubmitBtn = this.querySelector(`#StickyProductSubmitButton-${this.sectionId}`);
      if (stickySubmitBtn) {
        const btnText = stickySubmitBtn.querySelector('span');
        if (!variant.available) {
          stickySubmitBtn.setAttribute('disabled', 'disabled');
          if (btnText) btnText.textContent = window.variantStrings?.soldOut || 'Sold out';
        } else {
          stickySubmitBtn.removeAttribute('disabled');
          if (btnText) btnText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      // Sync price with compare-at price
      if (html) {
        const destinationPrice = this.querySelector(`#price-${this.sectionId}-sticky`);
        const sourcePrice = html.querySelector(`#price-${sectionId}`) || html.querySelector('.price');
        if (destinationPrice && sourcePrice) {
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }
      }
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}